/*
 *
 * ServiceConfig
 *
 * @version 1.0.0
 * @author Alessandro Mosca
 * @since 31-Jan-2025
 */

import ServiceConfig from './ServiceConfig'

export default ServiceConfig
